import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../CustomBody/index";
import LogisticCard from "./LogisticCard";

//Assets
import LogisticParcel from "../../../../images/logistic-parcel.png";

//Interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  loading,
  rateType,
  logisticList,
  convertDate,
  disableRegular,
  disableExpress,
  onSelectHandler,
  checkCourierExpired,
  onBack,
  setToExpress,
  setToRegular,
}) => {
  return (
    <CustomBody loading={loading} className="select-logistic-wrapper" withBack backAction={onBack}>
      <>
        <div className="select-logistic-body">
          <p className="header">Select Logistic</p>
          <div className="tab">
            <button onClick={setToRegular} className={`rate-type regular ${disableRegular ? "disable" : rateType === "regular" ? "active" : ""}`}>
              <span>Regular</span>
            </button>
            <button onClick={setToExpress} className={`rate-type ${disableExpress ? "disable" : rateType === "express" ? "active" : ""}`}>
              <span>Express</span>
            </button>
          </div>
          <div className="card-wrapper">
            {
              logisticList?.length ? logisticList.map(list => {
                return <LogisticCard checkCourierExpired={checkCourierExpired} selected={false} onSelectHandler={onSelectHandler} data={list} />
              }) : null
            }
          </div>
        </div>
        <div className="info-wrapper">
          <KickImage src={LogisticParcel} alt="..." />
          <p>Your package must arrive before <span>{convertDate}</span></p>
        </div>
      </>
    </CustomBody>
  )
}

export default Component;